import axios from "./configs/axiosConfig";

export const verifyClient = async (reqData) => {
  const url = `/jbwservicetitan`;
  return await axios.post(url, reqData);
};
